document.addEventListener('DOMContentLoaded', function () {
  try {
    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Map block-style suffixes to AOS attributes, but ONLY on Gutenberg blocks
    function mapBySuffix(suffix, type, delay) {
      var selector =
        '.wp-block-heading[class*="' + suffix + '"],' +
        'p[class*="' + suffix + '"],' +
        '.wp-block-buttons[class*="' + suffix + '"],' +
        '.wp-block-column[class*="' + suffix + '"]';

      var nodes = document.querySelectorAll(selector);
      if (!nodes.length) return;

      Array.prototype.forEach.call(nodes, function (el) {
        el.setAttribute('data-aos', type);
        if (typeof delay === 'number') {
          el.setAttribute('data-aos-delay', String(delay));
        } else {
          el.removeAttribute('data-aos-delay');
        }
      });
    }

    // Fade up variants
    mapBySuffix('fade-up-50', 'fade-up', 50);
    mapBySuffix('fade-up-150', 'fade-up', 150);
    mapBySuffix('fade-up-300', 'fade-up', 300);
    mapBySuffix('fade-up-450', 'fade-up', 450);

    // Fade in variants
    mapBySuffix('fade-in-50', 'fade-in', 50);
    mapBySuffix('fade-in-150', 'fade-in', 150);
    mapBySuffix('fade-in-300', 'fade-in', 300);
    mapBySuffix('fade-in-450', 'fade-in', 450);

    // Initialize AOS (no extra options), but skip animations for reduced motion users.
    if (!prefersReducedMotion && typeof AOS !== 'undefined') {
      AOS.init({
        once: true, // animate only first time
      });
    }
  } catch (e) {
    if (window.console && console.warn) {
      console.warn('Theme AOS script error:', e);
    }
  }
});
